// File drop zone hook for showing drag-and-drop overlay
// Works with Phoenix LiveView's phx-drop-target attribute
const FileDropZone = {
  mounted() {
    this.dragCounter = 0;

    // Store bound handlers as instance properties
    this.boundHandleDragEnter = this.handleDragEnter.bind(this);
    this.boundHandleDragLeave = this.handleDragLeave.bind(this);
    this.boundHandleDragOver = this.handleDragOver.bind(this);
    this.boundHandleDrop = this.handleDrop.bind(this);

    // Add event listeners to window for global drag detection
    window.addEventListener('dragenter', this.boundHandleDragEnter, false);
    window.addEventListener('dragleave', this.boundHandleDragLeave, false);
    window.addEventListener('dragover', this.boundHandleDragOver, false);
    window.addEventListener('drop', this.boundHandleDrop, false);
  },

  destroyed() {
    // Clean up event listeners
    window.removeEventListener('dragenter', this.boundHandleDragEnter, false);
    window.removeEventListener('dragleave', this.boundHandleDragLeave, false);
    window.removeEventListener('dragover', this.boundHandleDragOver, false);
    window.removeEventListener('drop', this.boundHandleDrop, false);
  },

  handleDragEnter(e) {
    // Only show overlay if files are being dragged
    if (e.dataTransfer.types.includes('Files')) {
      this.dragCounter++;
      this.el.classList.remove('hidden');
      this.el.classList.add('flex');
    }
  },

  handleDragLeave(e) {
    this.dragCounter--;

    if (this.dragCounter === 0) {
      this.el.classList.add('hidden');
      this.el.classList.remove('flex');
    }
  },

  handleDragOver(e) {
    // Prevent default to allow drop
    e.preventDefault();
    e.stopPropagation();
  },

  handleDrop(e) {
    // Reset counter and hide overlay
    this.dragCounter = 0;
    this.el.classList.add('hidden');
    this.el.classList.remove('flex');

    // Let LiveView's phx-drop-target handle the actual file upload
    // We just provide the visual feedback
  }
};

export default FileDropZone;
